'use strict';

registerModule('prototyping');

/**
 * Clamp a number between two values
 * @type {function(number: number, lower: number, upper: number): number}
 */
Math.clamp = Math.clamp || function(number, lower, upper) {
    return this.min(this.max(number, lower), upper);
}

/**
 * Add an event listener to all items in this NodeList
 * @see Node.prototype.on
 * @returns {NodeList}
 */
NodeList.prototype.on = function(...props) {
    this.forEach(item => item.on(...props));
    return this;
};

/**
 * Filters the NodeList collection and returns an array with the filtered nodes.
 * @param {(value: Element, index: number, array: Element[]) => boolean} predicate
 * @param {*} [thisArg]
 * @return {Element[]}
 */
NodeList.prototype.filter = function(predicate, thisArg) {
    return Array.from(this).filter(predicate, thisArg);
};

/**
 * Maps all values from the node list.
 * @param {(value: T, index: number, array: T[]) => unknown} callbackfn
 * @param {any} thisArg
 * @return ?[]
 */
NodeList.prototype.map = function(callbackfn, thisArg) {
    return Array.from(this).map(callbackfn, thisArg);
};

/**
 * Overwrites the addEventListener handler to add a jQuery-like selector support.
 * @param {string} type
 * @param {EventListenerOrEventListenerObject|string|null} listenerOrSelector
 * @param {EventListenerOrEventListenerObject|null|AddEventListenerOptions|boolean} [listenerOrObject]
 * @param {AddEventListenerOptions|boolean|undefined} [options]
 * @returns {Node}
 */
Node.prototype.on = function(type, listenerOrSelector, listenerOrObject, options) {
    EventTarget.prototype.addEventListener.call(this, type, event => {
        // If the 2nd argument is NOT a selector (string), run as normal.
        if (typeof(listenerOrSelector) !== 'string') {
            listenerOrSelector(event);
        } else {
            // See if the selector has a result
            const target = event.target.closest(listenerOrSelector);
            if (target) {
                // Hack in the currentTarget property as it is read-only by default.
                Object.defineProperty(event, 'currentTarget', {
                    value: target,
                    writable: false,
                });

                listenerOrObject(event);
            }
        }
    }, typeof(listenerOrSelector) === 'string' ? options : listenerOrObject);

    return this;
}

console.debug('Prototypes set up');

export default "test";
